/**
 * src/hooks/useClientes.js
 * React Query v5 hooks para CRUD de clientes.
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  getClientes, getCliente, createCliente, updateCliente,
  deleteCliente, addCompetidor, updateCompetidor, updateEmpresa, updateScheduler,
} from '../api/clientes'

export function useClientes(soloActivos = true) {
  return useQuery({
    queryKey: ['clientes', { soloActivos }],
    queryFn: () => getClientes(soloActivos),
  })
}

export function useCliente(clienteId) {
  return useQuery({
    queryKey: ['clientes', clienteId],
    queryFn: () => getCliente(clienteId),
    enabled: !!clienteId,
  })
}

export function useCreateCliente() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: createCliente,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['clientes'] }),
  })
}

export function useUpdateCliente(clienteId) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data) => updateCliente(clienteId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['clientes'] }),
  })
}

export function useDeleteCliente() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: deleteCliente,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['clientes'] }),
  })
}

export function useAddCompetidor(clienteId) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data) => addCompetidor(clienteId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['clientes', clienteId] }),
  })
}

export function useUpdateCompetidor(clienteId) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ compId, data }) => updateCompetidor(clienteId, compId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['clientes', clienteId] }),
  })
}

export function useUpdateEmpresa(clienteId) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ empId, data }) => updateEmpresa(clienteId, empId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['clientes', clienteId] }),
  })
}

export function useUpdateScheduler(clienteId) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data) => updateScheduler(clienteId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['clientes', clienteId] }),
  })
}
